import interceptors from "./interceptors/index";

const createReport = (data) => {
  const { type, ...rest } = data;

  //faldones oracle reports
  if (type === "Downloads" || type === "Changes") {
  
    const params = new URLSearchParams({ type: type.toLowerCase() });
    if (rest.start_date) params.append("since", rest.start_date);
    if (rest.end_date) params.append("until", rest.end_date);
    return interceptors({
      url: `/online-promocional/faldones/reports?${params.toString()}`,
      method: "GET"
    }).then(response => {
      // Mock the standar structure .data
      let dataArr = Array.isArray(response.data) ? response.data : [];
      return { ...response, data: { data: dataArr } };
    });

  } else {
    //others reports
    return interceptors({
      url: "/documents/report",
      method: "POST",
      data
    });
  }
};


export { createReport };
